import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery } from '@tanstack/react-query';
import { MenuFileApi } from 'api';
import type { MenuFile } from 'api/methods/MenuFileApi';

/**
 * [MenuFile] Query Key 생성
 * --
 */
export const menuFileQueryKeys = createQueryKeys('menu_file', {
  getMenuFile: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getMenuFiles: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [MenuFile] 메뉴 파일 전체 조회
 * --
 */
export const useGetMenuFiles = (params?: {
  [key: string]: string | number;
}) => {
  const data = useQuery({
    queryKey: menuFileQueryKeys.getMenuFiles(params).queryKey,
    queryFn: () => MenuFileApi.getMenuFiles(params),
  });

  return data;
};

/**
 * [MenuFile] 메뉴 파일 상세 조회
 * --
 */
export const useGetMenuFile = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: menuFileQueryKeys.getMenuFile(idx, params).queryKey,
    queryFn: () => MenuFileApi.getMenuFile(idx, params),
  });

  return data;
};

/**
 * [MenuFile] 메뉴 파일 생성
 * --
 */
export const useCreateMenuFile = (body: MenuFile) => {
  const { mutateAsync: createMenuFile, ...result } = useMutation({
    mutationFn: (variables: MenuFile) => MenuFileApi.createMenuFile(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createMenuFile, ...result };
};

/**
 * [MenuFile] 메뉴 파일 수정
 * --
 */
export const useUpdateMenuFile = (body: MenuFile) => {
  const { mutateAsync: updateMenuFile, ...result } = useMutation({
    mutationFn: (variables: MenuFile) => MenuFileApi.createMenuFile(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateMenuFile, ...result };
};

/**
 * [MenuFile] 메뉴 파일 삭제
 * --
 */
export const useDeleteMenuFile = (idx: number) => {
  const { mutateAsync: deleteMenuFile, ...result } = useMutation({
    mutationFn: (variables: number) => MenuFileApi.deleteMenuFile(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteMenuFile, ...result };
};
